exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.por-project-child-card{min-height:63px;display:flex;width:100%;border-bottom:1px solid #b8b8b8;cursor:pointer}.por-project-child-card .project-child-icon-container{position:relative;margin-left:16px;margin-right:6px;width:20px;height:100%;min-height:64px}.por-project-child-card .project-child-icon-container .project-child-icon{position:absolute;left:0;top:calc(50% - 8px);width:20px;height:17px;background-image:url(" + require("../../../../assets/images/por-project-nav-icon.svg") + ");background-repeat:no-repeat;background-size:20px 17px}.por-project-child-card .project-child-info{display:flex;flex-direction:column;margin-top:12px;justify-content:center;align-items:center;margin-bottom:12px}.por-project-child-card .project-child-info .project-child-name{width:168px;line-height:14px;font-family:Open Sans,sans-serif;font-size:12px;font-weight:700;color:#8b8b8b;margin-bottom:3px}.por-project-child-card .project-child-info .project-child-id{width:168px;height:12px;font-family:Open Sans,sans-serif;font-size:10px;line-height:1;letter-spacing:normal;color:#8b8b8b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.por-project-child-card.selected{background-color:#3e3e3e}.por-project-child-card.selected .project-child-info .project-child-address,.por-project-child-card.selected .project-child-info .project-child-id,.por-project-child-card.selected .project-child-info .project-child-name{color:#fff}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/PORNav/PORProjectChildCard/PORProjectChildCard.scss
// module id = 1769
// module chunks = 0